/**
 * Slugs dos templates oficiais suportados pelo endpoint autenticado
 * `GET /templates/:type/download` do serviço sov-v2-files.
 *
 * Os valores devem espelhar exatamente o enum `TemplateType` do backend. O `type`
 * nunca é montado a partir de input livre do cliente — é sempre uma chave fixa de
 * lookup, o que evita path traversal no servidor.
 */
export enum TEMPLATE_TYPE {
  CADASTRAL_POSITION = 'cadastral-position',
  CADASTRAL_DATA_MATCHING = 'cadastral-data-matching',
  MOVE_INCLUSION = 'move-inclusion',
  MOVE_EXCLUSION = 'move-exclusion',
  MOVE_ALTERATION = 'move-alteration',
  MOVE_INCLUSION_BRADESCO = 'move-inclusion-bradesco',
  MOVE_EXCLUSION_BRADESCO = 'move-exclusion-bradesco',
  MOVE_INCLUSION_ODONTOPREV = 'move-inclusion-odontoprev',
}
